(function () {

    angular
        .module('harriApp.interviewV2')
        .controller('InterviewInviteModalController', [
            '$scope', 'modalData', 'onHide', 'onSave', 'brandServices', 'InterviewViewService', 'InterviewDataService',
            'InterviewSettingsForm', 'InterviewOpenDayForm', 'InterviewCalendarForm', 'userPermissions',
            function ($scope, modalData, onHide, onSave, brandServices, InterviewViewService, InterviewDataService,
                      InterviewSettingsForm, InterviewOpenDayForm, InterviewCalendarForm, userPermissions) {

                var copiedData = angular.copy(modalData);
                var lastCalendarForm;
                var viewService = InterviewViewService({});
                var interviewSetId;
                var oldCandidatesApplications = [];
                var selectedCandidate;
                var forms;


                var init = function () {
                    $scope.brandId = copiedData.brandId;
                    $scope.job = copiedData.job;
                    $scope.interviewType = copiedData.interviewType;
                    selectedCandidate = copiedData.selectedCandidates[0];

                    if (
                        selectedCandidate &&
                        selectedCandidate['interview_status'] &&
                        selectedCandidate['interview_status']['interview_set'] &&
                        selectedCandidate['interview_status']['interview_set']['id'] &&
                        ["WITHDRAWN", "DECLINED"].indexOf(selectedCandidate['interview_status']['status']) < 0
                    ) {
                        interviewSetId = selectedCandidate['interview_status']['interview_set']['id'];
                    }

                    forms = new FormGroup();
                    $scope.settingsForm = forms.addForm(InterviewSettingsForm($scope, viewService));
                    $scope.calendarForm = forms.addForm(InterviewCalendarForm($scope, viewService));
                    lastCalendarForm = $scope.calendarForm;

                    $scope.openDayEnabled = selectedCandidate?.interview_status?.interview_set?.type === "OPEN_DAY" ? true :false;

                    if ($scope.isInterviewV2ServiceEnabled) {
                        copiedData.locations.push({
                            formatted_address: $filter("translate")("Custom"),
                            id: "CUSTOM"
                        });
                    }
                };


                /**
                 * Save all forms and if valid send interview invite
                 */
                $scope.sendInvite = function () {
                    delete $scope.apiErrorMessage;
                    $scope.saving = true;
                    $scope.$evalAsync();

                    forms.saveAll(true)
                        .then(function (res) {
                            if ($scope.openDayEnabled) {
                                sendOpenDayInvite(res);
                            }
                            else {
                                sendSlotsInvite(res);
                            }
                        })
                        .catch(function (err) {
                            console.error(err);
                            $scope.saving = false;
                            $scope.$evalAsync();
                        });
                };

                var sendSlotsInvite = function (res) {
                    var settingsFormData = res[0];
                    var calendarFormData = res[1];

                    var applicationsToSend = [];
                    for (var a in settingsFormData.selected_candidates) {
                        applicationsToSend.push({
                            application_id: settingsFormData.selected_candidates[a]['application_id'],
                            user_id: settingsFormData.selected_candidates[a]['id']
                        });
                    }
                    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

                    var payload = {
                        allow_overlap: !!settingsFormData.interview_overlap,
                        duration: (parseInt($scope.calendarForm.getDuration()) * 60),
                        slots: InterviewDataService.retrieveSlotsToSave(),
                        applications: applicationsToSend,
                        message: {
                            message: settingsFormData.message
                        },
                        applied_timezone: timezone,
                        attachments: settingsFormData.attachments || []
                    };

                    if (settingsFormData.interviewCategory) {
                        payload.category = settingsFormData.interviewCategory;
                        if (settingsFormData.interviewCategory === 'VIDEO_INTERVIEW') {
                            payload.video_interview_link = settingsFormData.video_link;
                        }
                    }

                    var location;
                    if ($scope.interviewType !== 'PHONE' && settingsFormData?.interviewCategory !== 'VIDEO_INTERVIEW') {
                        if (settingsFormData.selected_location?.id === 'CUSTOM') {
                            var customLocation = settingsFormData.custom_location.value;

                            if (customLocation.id && customLocation.google_place_id) {
                                location = customLocation;
                            } else {
                                location = {
                                    'google_place_id': customLocation.result.place_id,
                                    'latitude': customLocation.result.geometry.location.lat,
                                    'longitude': customLocation.result.geometry.location.lng,
                                    'formatted_address': customLocation.result.formatted_address
                                };
                            }
                        } else {
                            location = settingsFormData.selected_location;
                        }
                        payload['location'] = location;
                    }

                    if ($scope.isInterviewV2ServiceEnabled) {
                        payload.interviewers = _.map(settingsFormData.interviewers, function (value) {
                            return { user_id: value.user.id };
                        });
                    }

                    if (!$scope.isInterviewV2ServiceEnabled) {
                        delete payload['interviewers'];
                    }

                    if (interviewSetId) {

                        // search for duplicate applicants which means someone has a changed interview
                        // and then concatenate the old and new applicants together
                        if (oldCandidatesApplications && oldCandidatesApplications.length) {
                            var duplicates = [];
                            for (var app in payload['applications']) {
                                var applicant = payload['applications'][app];

                                for (var old in oldCandidatesApplications) {
                                    var oldApplicant = oldCandidatesApplications[old];

                                    if (applicant.application_id === oldApplicant.application_id) {
                                        duplicates.push(applicant.application_id);
                                        payload['applications'].splice(app, 1);
                                        break;
                                    }
                                }
                            }

                            payload['applications'] = payload['applications'].concat(oldCandidatesApplications);

                            payload['applications'] = _.uniq(payload['applications'], function (value) {
                                return value.application_id && value.user_id;
                            });

                            if (duplicates.length) {
                                payload['force_changes_for'] = duplicates;
                            }
                        }

                        updateInterviewSet(payload);
                    }
                    else {
                        createInterviewSet(payload);
                    }
                };

                var showErrorAlert = function (error) {

                    var errorMsg;
                    switch (error.data.errors[0].code) {
                        case InterviewV2API.ERROR_CODES.CAN_NOT_REMOVE_CONFIRMED_SLOT:
                            errorMsg = "Confirmed slots can't be removed";
                            break;
                        case InterviewV2API.ERROR_CODES.OVERLAP_NOT_ALLOWED:
                            errorMsg = "Interview slots can't overlap";
                            break;
                        case InterviewV2API.ERROR_CODES.INTERVIEWERS_HAVE_CONFIRMED_SLOTS:
                            errorMsg = "Selected interviewers have booked interviews";
                            break;
                        case InterviewV2API.ERROR_CODES.SLOT_DOES_NOT_MATCH_DURATION:
                            errorMsg = "Slots must all have the same size of the interview duration";
                            break;
                    }

                    if (
                        errorMsg &&
                        error.data.errors[0].detail &&
                        error.data.errors[0].detail.extra &&
                        error.data.errors[0].detail.extra.start_time
                    ) {
                        errorMsg += " at ";
                        errorMsg += moment(error.data.errors["0"].detail.extra.start_time).format("MMM DD, YYYY hh:mm a");
                    }

                    $scope.apiErrorMessage = errorMsg || "Something went wrong";
                };

                var updateInterviewSet = function (payload) {
                    delete payload['type'];

                    InterviewV2API.updateBrandInterviewSet($scope.brandId, interviewSetId, payload)
                        .then(function (response) {
                            onSaveModal(payload);
                        }, function (error) {
                            console.error(error);
                            $scope.saving = false;
                            if (error && error.data && error.data.errors && error.data.errors[0]) {
                                showErrorAlert(error);
                            }
                            $scope.$digest();
                        });
                };

                var createInterviewSet = function (payload) {
                    payload['type'] = $scope.isInterviewV2ServiceEnabled ? ($scope.interviewType || "INVITE") : "JOB";
                    payload['job_id'] = $scope.job.id;

                    InterviewV2API.saveBrandInterviewSet($scope.brandId, payload)
                        .then(function (response) {
                            onSaveModal(payload);
                        }, function (error) {
                            console.error(error);
                            $scope.saving = false;
                            if (error && error.data && error.data.errors && error.data.errors[0]) {
                                showErrorAlert(error);
                            }
                            $scope.$digest();
                        });
                };

                var onSaveModal = function (payload) {
                    var appIds = [];

                    for (var i in payload.applications) {
                        appIds.push(payload.applications[i].application_id);
                    }

                    InterviewV2API.getInterviewApplicantsStatuses($scope.brandId, $scope.job.id, appIds)
                        .then(function (appStatuses) {
                            var interview_statuses = [];

                            for (var i in appStatuses.applications) {
                                var cardUpdateData = {
                                    application_id: appStatuses.applications[i].application_id,
                                    interview_status: appStatuses.applications[i]
                                };

                                interview_statuses.push(cardUpdateData);
                            }

                            onSave(interview_statuses);

                            $scope.saving = false;

                            $scope.close();
                            $scope.$digest();
                        });
                };

                var sendOpenDayInvite = function (res) {
                    var settingsFormData = res[0];
                    var openDayFormData = res[1];

                    var applicationsToSend = [];
                    for (var a in settingsFormData.selected_candidates) {
                        applicationsToSend.push({
                            application_id: settingsFormData.selected_candidates[a]['application_id'],
                            user_id: settingsFormData.selected_candidates[a]['id']
                        });
                    }

                    var openDayInterviewSetId = openDayFormData.selectedOpenDayId;

                    InterviewV2API.sendOpendayInvite(
                        $scope.brandId,
                        $scope.job.id,
                        openDayInterviewSetId,
                        applicationsToSend
                    )
                        .then(function (response) {
                            onSaveModal({applications: applicationsToSend});
                        }, function (error) {
                            console.error(error);
                            $scope.saving = false;
                            $scope.$digest();
                        });
                };

                /**
                 * What to do when the open day toggle changes
                 * Call load open day form to populate from API
                 */
                $scope.handleToggleChange = function () {
                    if ($scope.openDayEnabled && $scope.isInterviewV2ServiceEnabled) {
                        var openDayForm = forms.addForm(InterviewOpenDayForm($scope));
                        forms.deleteForm($scope.calendarForm);
                        lastCalendarForm = $scope.calendarForm;
                        $scope.calendarForm = null;
                        $scope.openDayForm = openDayForm;
                        $scope.openDayForm.load({brandId: $scope.brandId, jobId: $scope.job.id});
                    }
                    else {
                        $scope.calendarForm = forms.addForm(InterviewCalendarForm($scope, viewService));
                        $scope.calendarForm.load(copiedData);
                        forms.deleteForm($scope.openDayForm);
                        $scope.openDayForm = null;
                    }

                    $scope.$digest();
                };

                $scope.onInterviewersChanged = function ($event) {
                    var interviewers = $event.val;
                    $scope.calendarForm.triggerInterviewersChanged(interviewers);
                };

                var getInterviewSetDetails = function () {
                    var deferred = $q.defer();

                    InterviewV2API.getInterviewSetDetails($scope.brandId, $scope.job.id, interviewSetId)
                        .then(function (response) {
                            var interviewSetData = response.interview_set;

                            deferred.resolve(interviewSetData);
                        }, function (error) {
                            console.error(error);
                            deferred.reject();
                        });

                    return deferred.promise;
                };

                var getJobInterviewSetsMeta = function () {
                    var deferred = $q.defer();

                    InterviewV2API.getJobInterviewSetsInfo($scope.brandId, $scope.job.id, false, $scope.interviewType)
                        .then(function (response) {
                            // if AQAAF job there must be an INTERVIEW SET ID
                            // and AQAAF jobs must be updated no created
                            // else create a new interview set with the defaults
                            var interviewSetData;
                            if (response.interview_set) {
                                interviewSetData = response.interview_set;
                                interviewSetData.defaults = false;
                            }
                            else {
                                interviewSetData = response.defaults;
                                interviewSetData.defaults = true;
                            }

                            deferred.resolve(interviewSetData);
                        }, function (error) {
                            console.error(error);
                            deferred.reject();
                        });

                    return deferred.promise;
                };

                var persistOldApplications = function (setInfo) {
                    if (setInfo.applications && setInfo.applications.length) {
                        oldCandidatesApplications = _.map(setInfo.applications, function (value) {
                            return {
                                application_id: value.application_id,
                                user_id: value.user_id
                            };
                        });
                    }
                    else {
                        oldCandidatesApplications = [];
                    }
                };

                (function () {
                    $scope.loading = true;

                    $q.all([
                        brandServices.checkAll(copiedData.brandId, [
                            brandServices.SERVICES.INTERVIEW_V2,
                            brandServices.SERVICES.AQAAF
                        ]),
                        userPermissions.getBrandPolicy(copiedData.brandId)
                    ])
                        .then(([services, policyParser]) => {
                            $scope.isInterviewV2ServiceEnabled = services[brandServices.SERVICES.INTERVIEW_V2];
                            $scope.isAQAAFServiceEnabled = services[brandServices.SERVICES.AQAAF];
                            $scope.canManageInterviewTemplates = policyParser.has(userPermissions.PERMISSIONS.MANAGE_QUESTION_BANK_VIDEO_INTERVIEW_FIELDS);

                            init();

                            if (interviewSetId) {

                                getInterviewSetDetails()
                                    .then(function (setInfo) {

                                        $scope.interviewSetExists = true;
                                        $scope.settingsForm.load(copiedData, setInfo);
                                        if ($scope.openDayEnabled && $scope.isInterviewV2ServiceEnabled) {
                                            forms.deleteForm($scope.calendarForm);
                                            $scope.calendarForm = null;
                                            const openDayForm = forms.addForm(InterviewOpenDayForm($scope));
                                            $scope.openDayForm = openDayForm;
                                            $scope.openDayForm.load({brandId: $scope.brandId, jobId: $scope.job.id, openDayId: setInfo.id});
                                        } else {
                                            $scope.calendarForm.load(copiedData, setInfo);
                                        }

                                        persistOldApplications(setInfo);

                                        $scope.loading = false;
                                        $scope.$digest();
                                    });
                            }
                            else {
                                getJobInterviewSetsMeta()
                                    .then(function (setMeta) {

                                        // not defaults returned then there is an interview set and I will use it
                                        if (!setMeta.defaults) {
                                            interviewSetId = setMeta.id;
                                            $scope.interviewSetExists = true;

                                            getInterviewSetDetails()
                                                .then(function (setInfo) {

                                                    $scope.settingsForm.load(copiedData, setInfo);
                                                    $scope.calendarForm.load(copiedData, setInfo);

                                                    persistOldApplications(setInfo);

                                                    $scope.loading = false;
                                                    $scope.$digest();
                                                });
                                        }
                                        else {
                                            $scope.settingsForm.load(copiedData, setMeta);
                                            $scope.calendarForm.load(copiedData, setMeta);
                                            $scope.loading = false;
                                            $scope.$digest();
                                        }
                                    });
                            }
                        });
                })();

                $scope.close = function () {
                    onHide();
                    lastCalendarForm.destroy();
                    $scope.settingsForm.destroy();
                    copiedData = {};
                    $scope.settingsForm = null;
                    $scope.calendarForm = null;
                    $scope.openDayForm = null;
                    $scope.$hide();
                };
            }]);
})();
